//@ts-check

module.exports = (fox) => {

	var _ = {
		getTranslation: function(alias) {
			var translation = {
				'proceed': fox.i18n.getTranslation('proceed', 'Proceed', 'dialog'),
				'cancel': fox.i18n.getTranslation('cancel', 'Cancel', 'dialog'),
				'secretTitle': fox.i18n.getTranslation('secretTitle', 'Enter secret password', 'dialog'),
				};
			return translation[alias] || '';
		}
	};

	fox.registerWidget('Security_Popup_Pass', {
		configure: function () {
			this.registerOptions('', {
				contentTemplate: 'popup_security_pass',
				onOkPress: (...args) => this.checkPass(...args),
				additionalClass: 'custom-popup-title',
				dialog:{
					buttons: [{
						text: 'Proceed',
						click: function () {},
						class: 'button-with-spinner mc-btn btn-small btn-casual white',
						id: 'on-success'
					},{
						text: 'Cancel',
						click: function () {},
						class: 'mc-btn btn-small btn-minor',
						id: 'on-cancel'
					}
				]}
				,

				widgets: {
					form: {
						formSelector: '#security-pass',
						handleWom: {
							notValid: {
								widget: '@this',
								event: 'form_not_valid',
								callback: (errors, widget) => {
									errors = errors.map(error => {
										error.message = widget.getElement(error.field).nodes[0].validationMessage;
										this.showError(error);
									});
								}
							},
						}
					},
					content:{
						handleDom:{
							forgot: {
								target: '#forgot-sc-pass',
								event: 'click',
								callback: '@parent:forgotPass'
							}
						}
					}
				}
			});
			this.callParent('configure', arguments);
		},
		init(){
			this.securityData = fox.site.wom1('~.Security_Data');
			this.callParent('init', arguments);
			this.disabled = false;
		},
		
		onCancel() {
			//this.removeError();
			this.hide();
			return fox.Promise.resolve(false);
		},

		hide() {
			this.enableButton();
			this.dom1('#sec-passwd').value = "";
			this.securityData.dispatchEvent('cancelPopup');
			this.callParent('hide', arguments);
		},

		checkPass(elt) {
			this.disableButton(elt);
			
			let form = this.wom1('#form');
			return form.submit().then(values => {
				if (! values) return;

				if (this.securityData.sc.setUserCredentials(values.passwd)) {
					this.hide();
					return true;
				} else {
					
					this.showError({message: 'Incorrect password', field: 'passwd'});
					return false;
				}
			}).catch((err) => {
				console.log(err);
			});
		},

		forgotPass(elt){
			elt.classList.add('spin');
			if (!this.disabled) {
				this.disabled = true;
				return this.securityData.sendVerificationMail.psend().then(resp => {
					elt.classList.remove('spin');
					this.disabled = false;
					this.hide();
					return this.securityData.popupForgot.show().then((res)=>{
						if (!res) {
							this.disabled = false;
							elt.classList.remove('spin');
							return fox.Promise.reject('Authorization canceled');
						}
					});
				}).catch(err =>  {
					this.disabled = false;
					elt.classList.remove('spin');
				});
			}
			
		}

	}, 'Popup_Form');
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/security-payment-details/widget/passPopup.es.js